import {
  reactive,
  Ref,
  ref,
  UnwrapRef,
  ComponentInternalInstance,
  getCurrentInstance,
  computed,
  ComputedRef,
  watch,
} from '@vue/composition-api';
import _ from 'lodash';
import { dispatchRouter } from '@/renderer/scripts/utils/tools/dispatchRouter';

import i18n, { i18n_t } from '@/locales/i18n';
import sidebarGuideHandler from '@/renderer/views/desktop/BaseSidebar/SidebarGuideHandler';
import ipc from '@/renderer/scripts/utils/ipc';
import tips from '@/renderer/scripts/utils/tips';
import smh from '@/renderer/scripts/smh';
import { RoleMap } from '@/renderer/scripts/utils/ConstantConfig';
import user from '@/renderer/scripts/utils/user';
import { industryCardListIds } from '@/renderer/scripts/utils/ConstantConfig/ConstantI18NConfig';
import { IS_PRIVATE } from '@/common/constant';

export type GuideCards = {
  title: string;
  text: string;
  icon: string;
  id: number;
  showCloseBnt?: boolean;
  show?: boolean;
};
type Handler = {
  initShow: Ref<boolean>;
  showSurvey: Ref<boolean>;
  showPersonalInfo: Ref<boolean>;
  advanceGuideCardId: Ref<number>;
  guideData: UnwrapRef<any>;
  guideCards: Array<GuideCards>;
  functionGuideCards: Ref<Array<GuideCards>>;
  advanceGuideCards: Ref<Array<GuideCards>>;
  isAdminGuide: ComputedRef<boolean>;
  methods: {
    customeCreateNoviceGuidance: () => Promise<void>;
    queryNoviceGuidance: () => Promise<void>;
    resetNoviceGuidance: () => Promise<void>;
    resetGuide: (val: any) => void;
    onGuideStep: (step: number) => void;
    handlerAdminCard: (id: number, isHandle?: boolean) => void;
    goAdminGuide: (type: string) => void;
    goSearchGuide: () => void;
    // finishGuideStep: (step: number, val?: any) => void;
    clickCloseBtn: (id: number) => void;
    getFunctionGuideShow: () => void;
    reportFunctionGuide: (id: number, action: string) => void;
    createTeam: () => void;
  };
};
export default function guideHandle(showDialog?: Record<string, boolean>): Handler {
  const currComponent: ComponentInternalInstance = getCurrentInstance() as ComponentInternalInstance;
  const vm = currComponent.proxy;
  const store = vm.$store;
  const initShow = ref(false);
  const showSurvey = ref(false);
  const showPersonalInfo = ref(false);
  const { inGuide } = sidebarGuideHandler();
  const guideData = reactive({
    advanceGuideFinished: [0, 0, 0, 0],
    // 新手引导基础的三个步骤的对应引导信息： 个人信息，个人空间，协作空间
    baseGuide: {
      personalDetail: {
        personalInfo: {},
        done: false,
      },
      personalSpace: {
        steps: [0, 0, 0],
        done: false,
      },
      collaborationSpace: {
        steps: [0, 0],
        done: false,
      },
      done: false,
    },
    // 新手引导完成后的结束弹窗是否已显示
    guideFinishedShow: false,
    // 搜索页面指引弹窗是否已经显示
    searchGuideFinished: false,
    didAdmin: {
      // 记录管理员的card是否操作过
      didAdminCard: [0, 0],
      // 判断是否进入过管理中心的
      didOpenManage: false,
      // 判断是否展示管理的蒙层
      didShowAdminGuide: false,
    },
    workbenchTools: {
      // 显示电子签
      showElectronCard: true,
      // 显示反勒索的卡片
      showAntiRansomwareCard: true,
      // 显示新手指引的气泡
      showGuideConfirm: false,
    },
  });

  const advanceGuideCardId = ref(0);
  const advanceGuideCards = ref([
    {
      id: 1,
      title: i18n_t('助力企业安全管理'),
      text: i18n_t('简单高效地管理企业员工和资产安全，轻松进行数据统计。'),
      icon: 'admin-step-1',
    },
    {
      id: 2,
      title: i18n_t('助力员工高效工作'),
      text: i18n_t('与同事共同管理资料，创建外部协作空间并实现在线协作。'),
      icon: 'admin-step-2',
    },
  ]);
  const functionGuideCards = ref([
    {
      id: 3,
      title: i18n_t('电子签上线啦'),
      text: i18n_t('电子合同模版一键发起，高效又省心。'),
      icon: 'guide-step-5',
      showCloseBnt: true,
      show: false,
    },
    {
      id: 4,
      title: i18n_t('企业网盘防勒索能力'),
      text: i18n_t('全方位守护企业资产，检测防护勒索病毒。'),
      icon: 'guide-step-6',
      showCloseBnt: true,
      show: false,
    },
  ]);
  const guideCards = [
    {
      id: 5,
      title: i18n_t('多端资料同步，加密分享'),
      text: i18n_t('简单高效地管理企业员工和资产安全，轻松进行数据统计。'),
      icon: 'guide-step-4',
    },
    {
      id: 6,
      title: i18n_t('和同事一起协作'),
      text: i18n_t('创建协作空间，邀请同事一起管理资料，在线编辑办公文档。'),
      icon: 'guide-step-3',
    },
  ];

  // 只有当企业版并且是管理员展示管理员引导弹窗
  const isAdminGuide = computed(() => {
    const { editionFlag, userRole } = store.getters;
    return editionFlag === 'enterprise' && userRole !== RoleMap.User && userRole !== RoleMap.TeamAdmin;
  });
  const functionKeyMap: Record<number, string> = {
    3: 'showElectronCard',
    4: 'showAntiRansomwareCard',
  };
  let titleClickTimes = 0; // 彩蛋：次数
  let titleClickTimer = 0; // 彩蛋：定时器
  const methods = {
    startGuide() {
      const { userRole, orgChannel } = user.getUserInfo();
      // 如果是免费用户且是超级管理员，直接return
      if (orgChannel === 'official-free' && userRole === RoleMap.SuperAdmin) return;
      // 私有化版本不显示welcome弹窗
      if (IS_PRIVATE) return;
      // 打开welcome弹窗
      if (showDialog) showDialog.welcome = true;
    },
    async customeCreateNoviceGuidance() {
      // 默认插入数据
      try {
        await smh.userAPI.createNoviceGuidance({
          ...guideData,
        });
      } catch (e) {
        tips.error(e as MsgError);
      }
    },
    async queryNoviceGuidance() {
      const { userBaseInfo } = store.getters;
      const { isTemporary } = userBaseInfo;
      if (isTemporary) return;
      try {
        const { data } = await smh.userAPI.queryNoviceGuidance();
        if (_.isEmpty(data.data)) {
          methods.startGuide();
        }
        const newData = {
          ...guideData,
          ...data.data,
        };
        // 测试用将数据初始化的
        // newData.advanceGuideFinished = [];
        store.commit('setNoviceGuidance', newData);
        initShow.value = true;
      } catch (error: any) {
        if (error.code === 'NoviceGuidanceNotFound') {
          initShow.value = true;
          store.commit('setNoviceGuidance', {
            ...guideData,
          });
          methods.startGuide();
          return;
        }
        tips.error(error as MsgError);
      }
    },
    async resetNoviceGuidance() {
      const { userRole, orgChannel } = user.getUserInfo();
      try {
        // 清空留咨数据，方便测试(供超管调用)clear
        if (userRole === RoleMap.SuperAdmin && orgChannel !== 'official-free') {
          await smh.userAPI.deleteSurvey();
        }
        await smh.userAPI.createNoviceGuidance({});
        window.location.reload();
      } catch (error: any) {
        tips.error(error as MsgError);
      }
    },
    onGuideStep(step: number) {
      const { baseGuide } = store.getters.noviceGuidance;
      switch (step) {
        case 5: {
          // 如果任务完成也不可点击
          if (baseGuide?.personalSpace.done) return;
          dispatchRouter({
            name: 'personalSpace',
            params: {
              guide: 'true',
            },
          });
          reporter.report('check_guide', {
            guide_detail: 'show',
          });
          break;
        }
        case 6: {
          // 如果任务完成也不可点击
          if (baseGuide?.collaborationSpace.done) return;
          dispatchRouter({
            name: 'collaborationSpace',
            params: {
              guide: 'true',
            },
          });
          reporter.report('share_guide', {
            guide_detail: 'show',
          });
          break;
        }
        default: {
          break;
        }
      }
    },
    async handlerAdminCard(id: number, isHandle?: boolean) {
      if (inGuide.value) return;
      const { advanceGuideFinished, didAdmin } = store.getters.noviceGuidance;
      // 这里不做关闭电子签的处理 (按现有逻辑)
      if (id < 3 && !isHandle) {
        advanceGuideFinished.splice(id, 1, 1);
      }
      if (industryCardListIds.includes(id)) {
        advanceGuideFinished.splice(3, 1, 1);
      }
      if (isHandle) didAdmin?.didAdminCard.splice(id, 1, 1);
      try {
        const opt = {
          ...store.getters.noviceGuidance,
          advanceGuideFinished,
          didAdmin,
        };
        await smh.userAPI.createNoviceGuidance(opt);
        store.commit('setNoviceGuidance', opt);
      } catch (error: any) {
        tips.error(error as MsgError);
      }
    },
    // 彩蛋： alt+shift+标题部分点击五次，重置新手引导
    resetGuide(e: MouseEvent) {
      titleClickTimes++;
      if (titleClickTimes >= 5) {
        titleClickTimes = 0;
        if ((e.altKey || e.metaKey) && e.shiftKey) {
          this.resetNoviceGuidance();
        }
      }
      titleClickTimer && window.clearTimeout(titleClickTimer);
      titleClickTimer = window.setTimeout(() => {
        titleClickTimes = 0;
      }, 500);
    },
    async goAdminGuide(type: string) {
      const { didAdmin } = store.getters.noviceGuidance;
      if (type === 'manage') {
        didAdmin.didOpenManage = true;
        didAdmin?.didAdminCard.splice(0, 1, 1);
      } else {
        didAdmin.didShowAdminGuide = true;
      }
      try {
        const opt = {
          ...store.getters.noviceGuidance,
          didAdmin,
        };
        await smh.userAPI.createNoviceGuidance(opt);
        store.commit('setNoviceGuidance', opt);
      } catch (error: any) {
        tips.error(error as MsgError);
      }
    },

    async goSearchGuide() {
      try {
        const opt = {
          ...store.getters.noviceGuidance,
          searchGuideFinished: true,
        };
        await smh.userAPI.createNoviceGuidance(opt);
        store.commit('setNoviceGuidance', opt);
      } catch (error: any) {
        tips.error(error as MsgError);
      }
    },

    getFunctionGuideShow() {
      const { workbenchTools } = store.getters.noviceGuidance;
      const { isPrivate } = store.getters;
      functionGuideCards.value.forEach(item => {
        // 私有化不显示电子签卡片和防勒索
        if (!workbenchTools) {
          // 不存在默认为true
          item.show = true;
          if (isPrivate && [3, 4].includes(item.id)) {
            // 私有化不显示电子签卡片以及防勒索卡片
            item.show = false;
          }
          return;
        }
        // 电子签
        if (item.id === 3) {
          item.show = !!workbenchTools.showElectronCard && !isPrivate;
        }
        // 防勒索
        if (item.id === 4) {
          item.show = !!workbenchTools.showAntiRansomwareCard && !isPrivate;
        }
      });
    },
    async clickCloseBtn(id: number) {
      functionGuideCards.value.forEach(item => {
        if (item.id === id) {
          item.show = false;
          methods.reportFunctionGuide(item.id, 'card_click_close');
        }
      });
      const key = functionKeyMap[id];
      if (!key) {
        return;
      }
      const newOpt = {
        ...store.getters.noviceGuidance,
      };
      newOpt.workbenchTools[key] = false;

      // 修改后台配置
      try {
        await smh.userAPI.createNoviceGuidance(newOpt);
        store.commit('setNoviceGuidance', newOpt);
      } catch (error) {
        logger.ui.error('clickCloseBtn error', error);
      }
    },
    reportFunctionGuide(id: number, action: string) {
      reporter.report('function_guide', {
        id,
        action,
        isAdminGuide: isAdminGuide.value,
      });
    },
    createTeam() {
      if (inGuide.value) return;
      ipc.emit(ipc.RENDERER_EVENTS_MAP.SHOW_INVITE_DIALOG);
    },
  };
  watch(
    () => store.getters.noviceGuidance,
    val => {
      methods.getFunctionGuideShow();
    },
  );
  return {
    initShow,
    guideCards,
    functionGuideCards,
    advanceGuideCards,
    advanceGuideCardId,
    guideData,
    showSurvey,
    showPersonalInfo,
    methods,
    isAdminGuide,
  };
}
